export default __webpack_public_path__ + "static/media/revel-panel-bg.c0fe1322.webp";